import React from "react";
import {BaseComponent, ch, PageRouteProvider} from "@renta-apps/athenaeum-react-common";
import {SwitchNullable} from "@renta-apps/athenaeum-react-components";
import {FeatureSwitch} from "@/components/FeatureSwitch/FeatureSwitch";
import FeatureFlags from "@/helpers/FeatureFlags";
import UserContext from "@/models/server/UserContext";
import PageDefinitions from "@/providers/PageDefinitions";
import ViewPreferenceStorage from "@/providers/ViewPreferenceStorage";

import styles from "./ViewModeSwitch.module.scss";

interface IViewModeSwitchProps {
    anonymous?: boolean;
}

export default class ViewModeSwitch extends BaseComponent<IViewModeSwitchProps> {

    private get isMobilePreferred(): boolean {
        if (this.props.anonymous) {
            return ViewPreferenceStorage.get() === true;
        }
        const ctx = ch.getContext() as UserContext;
        const preference = ViewPreferenceStorage.get(ctx.email);
        if (preference !== null) {
            return preference;
        }
        return ctx.isMobileManager;
    }

    private get canSwitch(): boolean {
        if (this.props.anonymous) {
            return true;
        }
        const ctx = ch.getContext() as UserContext;
        return (ctx.isManager || ctx.isBusinessManager || ctx.isAdmin || ctx.isSalesPerson)
            && !ctx.isMobileManager;
    }

    private async onChangeAsync(preferMobile: boolean): Promise<void> {
        if (this.props.anonymous) {
            ViewPreferenceStorage.set(preferMobile);
            await this.reRenderAsync();
            return;
        }

        const ctx = ch.getContext() as UserContext;
        ViewPreferenceStorage.set(preferMobile, ctx.email);

        await this.postAsync("/api/Application/SetViewPreference", preferMobile);

        ch.reloadTopNav();

        const route = preferMobile
            ? PageDefinitions.rentaTasksRoute
            : PageDefinitions.dashboardRoute;
        await PageRouteProvider.redirectAsync(route);
    }

    public render(): React.ReactNode {
        if (!this.canSwitch) {
            return null;
        }

        return (
            <FeatureSwitch flagName={FeatureFlags.ViewModeSwitch}>
                <div className={styles.viewModeSwitch}>
                    <SwitchNullable excludeNull
                                    value={this.isMobilePreferred}
                                    leftLabel="Desktop"
                                    rightLabel="Mobile"
                                    onChange={async (_, checked) => await this.onChangeAsync(checked!)}
                    />
                </div>
            </FeatureSwitch>
        );
    }
}
